import React from 'react';
import { FaChevronRight } from 'react-icons/fa';

export default function pageTitle({ title, redirectURLTitle, redirectURL }) {
    return (
        <div className="main-title__wrapper">
            <h1 className="main-title__content">{title}</h1>
            <hr className="main-title__line flex-fill" />
            {redirectURLTitle && (
                <a className="main-title__link" href={redirectURL}>
                    <span> {redirectURLTitle} </span>
                    <span className="main-title__arrow">
                        <FaChevronRight />
                    </span>
                </a>
            )}
        </div>
    );
}
